import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import AirportInfoPage from "@/pages/AirportInfo";
import Hangars from "@/pages/Hangars";
import FuelPage from "@/pages/FuelPage";
import Gallery from "@/pages/Gallery";
import FlightSchools from "@/pages/FlightSchools";
import Reports from "@/pages/Reports";
import Contact from "@/pages/Contact";
import Leadership from "@/pages/Leadership";
import FeesPage from "@/pages/FeesPage";
import Attractions from "@/pages/Attractions";

import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminFuel from "@/pages/admin/AdminFuel";
import AdminHangars from "@/pages/admin/AdminHangars";
import AdminFlightSchools from "@/pages/admin/AdminFlightSchools";
import AdminPhotos from "@/pages/admin/AdminPhotos";
import AdminReports from "@/pages/admin/AdminReports";
import AdminAirportInfo from "@/pages/admin/AdminAirportInfo";
import AdminLeadership from "@/pages/admin/AdminLeadership";
import AdminFees from "@/pages/admin/AdminFees";
import AdminAttractions from "@/pages/admin/AdminAttractions";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Public><Home /></Public>} />
            <Route path="/airport" element={<Public><AirportInfoPage /></Public>} />
            <Route path="/hangars" element={<Public><Hangars /></Public>} />
            <Route path="/fuel" element={<Public><FuelPage /></Public>} />
            <Route path="/gallery" element={<Public><Gallery /></Public>} />
            <Route path="/flight-schools" element={<Public><FlightSchools /></Public>} />
            <Route path="/reports" element={<Public><Reports /></Public>} />
            <Route path="/leadership" element={<Public><Leadership /></Public>} />
            <Route path="/fees" element={<Public><FeesPage /></Public>} />
            <Route path="/attractions" element={<Public><Attractions /></Public>} />
            <Route path="/contact" element={<Public><Contact /></Public>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="airport-info" element={<AdminAirportInfo />} />
              <Route path="fuel" element={<AdminFuel />} />
              <Route path="hangars" element={<AdminHangars />} />
              <Route path="flight-schools" element={<AdminFlightSchools />} />
              <Route path="photos" element={<AdminPhotos />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="leadership" element={<AdminLeadership />} />
              <Route path="fees" element={<AdminFees />} />
              <Route path="attractions" element={<AdminAttractions />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
